// extracted by mini-css-extract-plugin
module.exports = {"topsolid":"fromUploadImg_topsolid_3TVgO","upload":"fromUploadImg_upload_3dc_h"};